import React from "react";
import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";
import Layout from "./../../global/Layout";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { StyledWrapper, StyledBody, StyledHeading } from "./styles";
import { toggleClientRoot } from "./../toggleClientRoute";

export const Page = ({ context, clientContext }) => {
  try {
    let { isMobile } = clientContext;
    let { page } = context.data;
    let pageData = page.items[0];
    let markdownEmbed = pageData?.fields?.body?.content?.[0]?.data?.target?.fields.markdownEmbed;
    let body = documentToHtmlString(pageData.fields.body);

    toggleClientRoot();
    return (
      <Layout context={context} clientContext={clientContext}>
        <StyledWrapper>
          <StyledBody isMobile={isMobile}>
            {pageData.fields.title && (
              <StyledHeading isMobile={isMobile}>
                {pageData.fields.title}
              </StyledHeading>
            )}
            <div
              className="basic-page-body"
              dangerouslySetInnerHTML={{ __html: body }}
            />
            {markdownEmbed && <InnerHTML html={markdownEmbed} className="basic-page-body"/>}
          </StyledBody>
        </StyledWrapper>
      </Layout>
    );
  } catch (error) {
    console.error("page", error);
  }

  return <NotFound />;
};

export default Page;

Page.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
};
